import { Pipe, PipeTransform } from '@angular/core';

import { semestres } from '../../../models/semestre';

@Pipe({
    name: 'semestre'
})
export class SemestrePipe implements PipeTransform {
    transform(semestre: number): string {
        if (!semestre) {
            return '';
        }

        const index = semestres.findIndex(semestreFilter => semestreFilter.semestre === semestre);
        if (index > -1) {
            return semestres[index].nome;
        }
        return '';
    }
}
